import { IconBell } from '@tabler/icons-react';
import { Indicator } from '@mantine/core';
import { useUnit } from 'effector-react';
import { $newTicketsCount } from '../model';

export const NewTickets = () => {
    const count = useUnit($newTicketsCount);

    if (!count) {
        return <IconBell color='gray' />;
    }

    return (
        <Indicator
            size={16}
            label={count}
            color='red'
        >
            <IconBell />
        </Indicator>
    );
};
